import styled from "styled-components";
import { Div } from "../common/ui/widgets";
import { UIWidgetsDiv } from "../common/ui/widgets/division/Division";

export const HomeUI = styled(Div)`
`;

export const PopupWrapper = styled(UIWidgetsDiv).attrs({
    name: "popup-wrapper"
  })`
    z-index: 110;
    position: fixed;
    top: ${(props) => props.theme.margin0};
    left: ${(props) => props.theme.margin0};
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    align-items: center;
    overflow: auto;
    > div:first-child {
      opacity: 0;
      position: absolute;
      width: 100%;
      height: 100%;
    }
    > div:nth-child(2) {
      position: relative;
      padding: ${(props) => props.theme.margin16};
      margin-top:25%
    }
  `;